// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"4d7b7f53","375":"4d7b7f53"}[chunkId] + ".chunk.css";
};